export var parseToNumber = function(value) {
    var parsedValue = parseInt(value !== null && value !== void 0 ? value : "");
    return Number.isInteger(parsedValue) ? parsedValue : undefined;
};
var BOOLEAN_VALUES = new Set([
    "true",
    "1"
]);
export var parseToBoolean = function(value) {
    return !!value && BOOLEAN_VALUES.has(value.toLowerCase());
};
export var parseToArray = function(rawValue, parseUtil) {
    if (!rawValue) {
        return [];
    }
    var value = Array.isArray(rawValue) ? rawValue : [
        rawValue
    ];
    return value.map(function(v) {
        var _parseUtil;
        return v ? (_parseUtil = parseUtil === null || parseUtil === void 0 ? void 0 : parseUtil(v)) !== null && _parseUtil !== void 0 ? _parseUtil : v : undefined;
    }).filter(Boolean);
};
